'use strict';

const rest = require('rest');
const defaultRequest = require('rest/interceptor/defaultRequest');
const mime = require('rest/interceptor/mime');
const uriTemplateInterceptor = require('./util/uriTemplateInterceptor');
const errorCode = require('rest/interceptor/errorCode');
const baseRegistry = require('rest/mime/registry');

const registry = baseRegistry.child();

registry.register('text/uri-list', require('./util/uriListConverter'));
registry.register('application/hal+json', require('rest/mime/type/application/hal'));

module.exports = rest
                 .wrap(mime, { registry: registry })
                 .wrap(uriTemplateInterceptor)
                 .wrap(errorCode)
                 .wrap(defaultRequest, { headers: { 'Accept': 'application/hal+json', 'Content-Type': 'application/hal+json' }});
